// Google Calendar colorId 對應顏色
// 色碼與 Google Calendar 介面完全一致
export const COLOR_MAP = {
  '1':  { name: '番茄紅',  hex: '#D50000', label: 'Tomato'    },
  '2':  { name: '火鶴粉',  hex: '#E67C73', label: 'Flamingo'  },
  '3':  { name: '橘紅',    hex: '#F4511E', label: 'Tangerine' },
  '4':  { name: '香蕉黃',  hex: '#F6BF26', label: 'Banana'    },
  '5':  { name: '鼠尾草綠',hex: '#51B749', label: 'Sage'      },
  '6':  { name: '羅勒綠',  hex: '#0B8043', label: 'Basil'     },
  '7':  { name: '孔雀藍',  hex: '#039BE5', label: 'Peacock'   },
  '8':  { name: '藍莓藍',  hex: '#3F51B5', label: 'Blueberry' },
  '9':  { name: '薰衣草紫',hex: '#7986CB', label: 'Lavender'  },
  '10': { name: '葡萄紫',  hex: '#8E24AA', label: 'Grape'     },
  '11': { name: '石墨灰',  hex: '#616161', label: 'Graphite'  },
  // 行事曆本身的底色（非事件顏色，但 API 也會回傳）
  'calendar_teal':  { name: '青色',   hex: '#009688', label: 'Teal'   },
  'calendar_blue':  { name: '藍色',   hex: '#4285F4', label: 'Blue'   },
  'calendar_green': { name: '綠色',   hex: '#0F9D58', label: 'Green'  },
  'calendar_red':   { name: '紅色',   hex: '#DB4437', label: 'Red'    },
  'calendar_pink':  { name: '粉紅',   hex: '#E91E63', label: 'Pink'   },
};

// 從 localStorage 讀取使用者設定的顏色→教練對應
export function getCoachColorSettings() {
  try {
    const saved = localStorage.getItem('coachColorSettings');
    return saved ? JSON.parse(saved) : {};
  } catch {
    return {};
  }
}

// 儲存顏色→教練對應
export function saveCoachColorSettings(settings) {
  localStorage.setItem('coachColorSettings', JSON.stringify(settings));
}

// 根據 colorId 取得教練名稱
export function getCoachByColorId(colorId) {
  const settings = getCoachColorSettings();
  return settings[colorId] || null;
}

// 解析事件標題，支援多位學員（團課用頓號或逗號分隔）
export function parseStudentNames(title) {
  if (!title) return [];
  return title
    .split(/[、,，]/)
    .map(s => s.trim())
    .filter(s => s.length > 0);
}
